import { gridsApi } from './api.js'
import { formatWeekGridName, weekMondayISO } from './utils.js'
import { useStore } from '../store/index.js'
import type { ScheduleGrid } from '../types/index.js'

/**
 * Retourne la grille hebdomadaire visible pour la date, ou en crée une vide.
 * Toute grille visible est immédiatement éligible au playout.
 */
export async function ensureWeeklyGrid(channelId: string, date: string): Promise<ScheduleGrid> {
  const monday = weekMondayISO(date)
  const result = await gridsApi.list({
    channelId,
    gridType: 'WEEKLY',
    weekStart: monday,
    limit: 50,
  })
  const existing = (result.data as ScheduleGrid[])
    .filter(grid => grid.status !== 'ARCHIVED' && grid.weekStart && weekMondayISO(grid.weekStart) === monday)
    .sort((left, right) =>
      new Date(right.updatedAt).getTime() - new Date(left.updatedAt).getTime()
    )[0]

  const grid = existing ?? await gridsApi.create({
    channelId,
    name: formatWeekGridName(date),
    gridType: 'WEEKLY',
    weekStart: `${monday}T00:00:00.000Z`,
  })

  const store = useStore.getState()
  store.upsertGrid(grid)
  store.setActiveGrid(grid.id)
  return grid
}
